import {nodeFromString} from "../tools/NodeFromString";

export default class CustomSelect {


    constructor(select, config = {}) {
        select.hidden = true;
        this.init(select, config)
    }

    initArgument(select) {
        this.select = {
            element: select,
            set value(value) {
                this.element.value = value
                this.element.dispatchEvent(new Event('change'))
            },
            get value() {
                return this.element.value;
            }
        }
    }

    initConfig(select, config = {}) {
        let defaultConfig = {
            class: 'index-dropdown',
            checkedClass: 'checked',
            openedClass: 'active',
            panel: {
                floating: false,
                class: 'index-dropdown__head',
                placeholderClass: 'index-dropdown__placeholder',
                labelClass: 'index-dropdown__select',
            },
            dropdown: {
                class: 'index-dropdown__options',
            },
            options: {
                class: 'index-dropdown__option',
                chosenClass: 'active',
                promptClass: 'prompt'
            },
        }
        this.config = Object.assign(defaultConfig, {
            multiple: select.hasAttribute('multiple'),
            disabled: select.hasAttribute('disabled'),
            placeholder: select.getAttribute('placeholder'),
            prompt: select.getAttribute('prompt'),
        }, config)

        if (select.hasAttribute('data-class')) {
            this.config.class += ' ' + select.getAttribute('data-class')
        }
    }

    initOptions(select) {
        this.options = [];

        [...select.options].forEach(option => {
            if (!option.value) {
                this.config.placeholder = option.innerHTML
            }
            this.options.push({
                value: option.value,
                label: option.innerHTML,
                selected: option.selected
            })
        })
    }

    renderOption(option) {
        let classes = [this.config.options.class]

        if (!option.value) {
            classes.push(this.config.options.promptClass)
        }
        if (option.value && option.selected) {
            classes.push(this.config.options.chosenClass)
        }

        return nodeFromString(`<li class="${classes.join(' ')}" tabindex="0">${option.label}</li>`)
    }

    renderSelect() {
        let renderPanel = () => {
            if (this.config.panel.floating) {
                return `
                    <div class="${this.config.panel.placeholderClass}">${this.config.placeholder ?? ''}</div>
                    <div cs-label class="${this.config.panel.labelClass}"></div>
                `
            }
            return `<span cs-label>${this.config.placeholder ?? ''}</span>`
        }


        return nodeFromString(`
            <div class="${this.config.class}">
                <div class="${this.config.panel.class}" tabindex="0">
                    ${renderPanel()}
                </div>
                <ul class="${this.config.dropdown.class}"></ul>
            </div>
        `)
    }

    createSelect() {
        this.customSelect = this.renderSelect()
        this.customSelect.placeholder = this.customSelect.querySelector('[cs-placeholder]')
        this.customSelect.label = this.customSelect.querySelector('[cs-label]')
        this.customSelect.panel = this.customSelect.querySelector('.' + this.config.panel.class.split(' ').join('.'))
        this.customSelect.dropdown = this.customSelect.querySelector('.' + this.config.dropdown.class.split(' ').join('.'))

        this.customSelect.panel.addEventListener('click', event => {
            event.preventDefault()
            this.toggle()
        })

        this.label = {
            element: this.customSelect.label,
            set value(placeholder) {
                this.element.innerHTML = placeholder
            },
            get value() {
                return this.element.innerHTML
            }
        }

        document.addEventListener('click', event => {
            if (this.isOpened() && !this.customSelect.contains(event.target)) {
                this.close()
            }
        })

        document.addEventListener('keydown', event => {
            switch (event.key) {
                case 'Enter':
                    if (this.customSelect.panel === document.activeElement) {
                        event.preventDefault()
                        this.toggle()
                    }
                    break;
                case 'ArrowUp':
                    if (this.isOpened()) {
                        event.preventDefault()
                        this.focus('prev')
                    }
                    break;
                case 'ArrowDown':
                    if (this.isOpened()) {
                        event.preventDefault()
                        this.focus('next')
                    }
                    break;
                case 'Escape':
                    if (this.isOpened()) {
                        event.preventDefault()
                        this.close()
                        this.focus()
                    }
            }
        })


    }

    createOption(option) {
        option.element = this.renderOption(option)
        option.element.addEventListener('click', () => this.choose(option))
        option.element.addEventListener('keydown', event => {
            if (event.key === 'Enter') {
                event.preventDefault()
                this.choose(option)
            }
        })
    }

    renderOptions() {
        this.customSelect.dropdown.append(...this.options.map(option => {
            this.createOption(option)
            return option.element
        }))
    }

    open() {
        this.customSelect.classList.add(this.config.openedClass)
    }

    close() {
        this.customSelect.classList.remove(this.config.openedClass)
    }

    toggle() {
        this.isOpened() ? this.close() : this.open()
    }

    isOpened() {
        return this.customSelect.classList.contains(this.config.openedClass)
    }

    focus(key) {
        let findFocusedOptionIndex = () => {
                return this.options.findIndex(option => option.element === document.activeElement) ?? 0;
            },
            focusByIndex = index => {
                this.options[index]?.element.focus()
            },
            focusPrev = () => {
                let focused = findFocusedOptionIndex()
                focusByIndex(focused > 0 ? focused - 1 : focused)
            },
            focusNext = () => {
                let focused = findFocusedOptionIndex()
                focusByIndex(focused + 1)
            }
        switch (key) {
            case 'prev':
                focusPrev()
                break;
            case 'next':
                focusNext()
                break;
            case Number.isInteger(key):
                focusByIndex(key)
                break;
            default:
                this.customSelect.panel.focus()
        }
    }

    choose(option, focus = true) {
        let floating = () => {
                if (option.value) {
                    this.label.value = option.label
                } else {
                    this.label.value = ''
                }
            },
            base = () => {
                this.label.value = option.label
            }

        this.options.forEach(option => option.element.classList.remove(this.config.options.chosenClass))

        if (option.value) {
            option.element.classList.add(this.config.options.chosenClass)
            this.config.checkedClass && this.customSelect.classList.add(this.config.checkedClass)
        } else {
            this.config.checkedClass && this.customSelect.classList.remove(this.config.checkedClass)
        }

        this.config.panel.floating ? floating() : base()


        this.chosenOption = option
        this.select.value = option.value
        this.close()

        focus && setTimeout(() => this.focus(), 10)
    }

    create(select) {
        this.createSelect()
        select.after(this.customSelect)
        select.CustomSelect = this
    }

    init(select, config = {}) {
        this.initArgument(select)
        this.initConfig(select, config)
        this.initOptions(select)
        this.create(select)
        this.renderOptions()

        this.chooseFromSelect()
    }

    chooseFromSelect() {
        let chosenOption = this.options.find(option => this.select.value === option.value)
        chosenOption && this.choose(chosenOption, false)
    }
}

document.querySelectorAll('[custom-select]').forEach(select => new CustomSelect(select))
document.querySelectorAll('[filter-custom-select]').forEach(select => new CustomSelect(select, {
    class: 'filter-dropdown',
    panel: {
        floating: true,
        class: 'filter-dropdown__head',
        placeholderClass: 'filter-dropdown__placeholder',
        labelClass: 'filter-dropdown__select',
    },
    dropdown: {
        class: 'filter-dropdown__options',
    },
    options: {
        class: 'filter-dropdown__option',
        chosenClass: 'active',
        promptClass: 'prompt'
    },
}))

